import React from 'react';
import { FaHeartbeat, FaHandsHelping, FaBookOpen, FaUsers } from 'react-icons/fa';

import {
  ActionButton,
} from './JoinUs.styles';

import { SectionContentWrapper, GlassContainer, WhiteCard } from '../About.styles';

const JoinUs: React.FC = () => {
  return (
    <GlassContainer>
      <WhiteCard>
        <SectionContentWrapper>
          <h2>
            <FaUsers style={{ marginRight: '0.5rem', color: '#039BE5' }} />
            Join Us
          </h2>
          <p>
            Your involvement is vital—whether through financial contributions, volunteering time,
            or attending events, you help shape a world where compassionate care is accessible,
            empowering, and transformative.
          </p>
          <div style={{ marginTop: '1rem' }}>
            <ActionButton to="/donate">
              <FaHeartbeat style={{ marginRight: '0.5rem' }} />
              Donate Now
            </ActionButton>
            <ActionButton to="/volunteer">
              <FaHandsHelping style={{ marginRight: '0.5rem' }} />
              Become a Volunteer
            </ActionButton>
            <ActionButton to="/events">
              <FaBookOpen style={{ marginRight: '0.5rem' }} />
              View Events
            </ActionButton>
          </div>
        </SectionContentWrapper>
      </WhiteCard>
    </GlassContainer>
  );
};

export default JoinUs;
